import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import InvitationForm from '../../../ProShare/components/InvitationForm';
import { breakpointDown } from '../../../../../../../../services/responsive/responsive';

const propTypes = {
  sendInvites: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

const PhoneStep = ({ sendInvites, onSuccess, submitting }) => {
  const isMobile = useMediaQuery(breakpointDown('sm'));

  return (
    <InvitationForm
      sendInvites={sendInvites}
      onSuccess={onSuccess}
      submitting={submitting}
      inputIsPhoneDefault
      allowInputTypeSelection={false}
      helperText={`Add mobile number and ${
        isMobile ? 'tap [done]' : 'press [return]'
      }`}
    />
  );
};

PhoneStep.propTypes = propTypes;

export default PhoneStep;
